import React, { forwardRef } from "react";
import * as RadixAvatar from "@radix-ui/react-avatar";
import "./Avatar.css";

const sizes = { xs: 22, sm: 28, md: 36, lg: 48, xl: 64 };

export const Avatar = forwardRef(function Avatar(
  { src, alt = "", initials = "", size = "md", ring = false, accent = null, className = "", ...props },
  ref
) {
  const px = typeof size === "number" ? size : sizes[size] || sizes.md;
  const fallback = initials || (alt || "").slice(0, 2).toUpperCase();
  const style = {
    "--av-size": `${px}px`,
    "--av-bg": accent || `linear-gradient(140deg, var(--primary), var(--primary-deep))`,
    ...props.style,
  };
  return (
    <RadixAvatar.Root
      ref={ref}
      className={`ui-avatar ${ring ? "ui-avatar-ring" : ""} ${className}`}
      style={style}
      {...props}
    >
      {src && (
        <RadixAvatar.Image
          src={src}
          alt={alt}
          className="ui-avatar-img"
        />
      )}
      <RadixAvatar.Fallback className="ui-avatar-fallback" delayMs={src ? 200 : 0}>
        {fallback || "?"}
      </RadixAvatar.Fallback>
    </RadixAvatar.Root>
  );
});
